import MBox from '@material-ui/core/Box';
import DeleteIcon from '@material-ui/icons/Delete';
import MFileCopyIcon from '@material-ui/icons/FileCopy';
import MFInfoIcon from '@material-ui/icons/Info';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import React, { useState } from 'react';
import styled from 'styled-components';
import { PreviewDialog, PreviewDialog2 } from '.';
import { Button, Checkbox, Container, CONTAINER, Dropdown, EditableLabel, IconButton, Label, Loading, RadioButton, Schedule, SearchField, Stepper, Switch, Tab, Table, Tabs, TextField, Tooltip, BLACK_GREY } from '../Components';
import { CROSS, DASH, EDIT, SEARCH, TICK } from '../Components/Svgs';

const TdHeader = styled.td`
    border: 2px solid #cccccc;
    padding: 16px;
`;

const Td = styled.td`
    border: 2px solid #cccccc;
    padding: 16px;
    min-width: 300px;
`;

export const Preview: React.FunctionComponent = () => {
    const [hideAll, setHideAll] = useState(false);
    const [switchState, setSwitchState] = useState(true);
    const [drowndownSelection, setDrowndownSelection] = useState("k1");
    const [textfieldValue, setTextfieldValue] = useState("This label");
    const [searchfieldValue, setSearchfieldValue] = useState("");
    const [editableLabelValue, setEditableLabelValue] = useState("This label");
    const [checkboxAChecked, setCheckboxAChecked] = useState(false);
    const [checkboxBChecked, setCheckboxBChecked] = useState(true);
    const [radioButtonChoice, setRadioButtonChoice] = useState("a");
    const [dialog1Open, setDialog1Open] = useState(false);
    const [dialog2Open, setDialog2Open] = useState(false);
    const [dialogSelection, setDialogSelection] = useState("hello");
    const [selectedTabKey, setSelectedTabKey] = useState("tab_1");
    const [selectedStep, setSelectedStep] = useState(0);
    const [selectedTableRowIndex, setSelectedTableRowIndex] = useState(-1);
    const [selectedRow, setSelectedRow] = useState(-1);
    const [firstRun, setFirstRun] = useState(true);
    const [rows, setRows] = useState([]);
    const dropdownItems = [
        { mykey: "k1", value: "Value 1" },
        { mykey: "k2", value: "Value 2" },
        { mykey: "k3", value: "Value 3" },
        { mykey: "k4", value: "Value 4" },
        { mykey: "k5", value: "Value 5" }
    ];

    const natoPhonetics = [
        "Alpha",
        "Bravo",
        "Charlie",
        "Delta",
        "Echo",
        "Foxtrot",
        "Golf",
        "Hotel",
        "India",
        "Juliet",
        "Kilo",
        "Lima",
        "Mike",
        "November",
        "Oscar",
        "Papa",
        "Quebec",
        "Romeo",
        "Sierra",
        "Tango",
        "Uniform",
        "Victor",
        "Whiskey",
        "Xray",
        "Yankee",
        "Zulu",
    ];

    const roles = ["Admin", "Metricell", "User", "Support"];

    function makeid(length) {
        let result = "";
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
            counter += 1;
        }
        return result;
    }

    function randomDate(start, end) {
        return new Date(
            start.getTime() + Math.random() * (end.getTime() - start.getTime())
        );
    }

    function msToTime(duration) {
        var minutes = Math.floor((duration / (1000 * 60)) % 60).toString(),
            hours = Math.floor((duration / (1000 * 60 * 60)) % 24).toString();

        hours = Number(hours) < 10 ? "0" + hours : hours;
        minutes = Number(minutes) < 10 ? "0" + minutes : minutes;

        return hours + ":" + minutes;
    }    

    if (firstRun) {
        // Change this to simulate larger tables, is used by very last table.
        const temp = [];

        const length = 4;
        for (let index = 0; index < length; index++) {
            let random_date = randomDate(new Date(1999, 0, 1), new Date());
            let display_date =
                random_date.getDate().toString() +
                "/" +
                random_date.getMonth().toString() +
                "/" +
                random_date.getFullYear().toString() +
                " " +
                msToTime(random_date.getTime());

            const x = {
                a: index,
                b: natoPhonetics[
                    Math.floor(Math.random() * natoPhonetics.length)
                ],
                c: natoPhonetics[
                    Math.floor(Math.random() * natoPhonetics.length)
                ],
                d: natoPhonetics[
                    Math.floor(Math.random() * natoPhonetics.length)
                ],
                e: natoPhonetics[
                    Math.floor(Math.random() * natoPhonetics.length)
                ],
                f:
                    natoPhonetics[
                        Math.floor(Math.random() * natoPhonetics.length)
                    ] +
                    "-" +
                    Math.floor(Math.random() * (0 - 1000 + 1) + 1000),
                g: "Charlie-" + makeid(1),
                h: true,
                UserRole: roles[Math.floor(Math.random() * roles.length)],
                i: makeid(3),
                j: display_date,
                k: false,
            };

            temp.push(x);
        }

        setRows(temp);

        setFirstRun(false);
    }

    const customReorderOne = (e: any) => {
        return e.f.charAt(e.f.length - 1);
    };

    const customReorderTwo = (e: any) => {
        return e.g.charAt(e.g.length - 1);
    };

    const customReorderThree = (e: any) => {
        switch (e[`UserRole`]) {
            case "Admin":
                return 1;
            case "Metricell":
                return 2;
            case "Support":
                return 3;
            case "User":
                return 4;
            default:
                return 777;
        }
    };

    const customReorderFour = (e: any) => {
        const val = e["j"].split(/[\s:/]+/);

        const date = new Date(val[2], val[1], val[0], val[3], val[4]);

        // Get epoch time
        return date.getTime() / 1000;
    };

    const onrowclick = (row: unknown, rowIndex: number) => {
        setSelectedRow(rowIndex);
    };

    const onCheckClick = (clickedRow: unknown) => {
        const newRows = rows.map((row) => ({...row, k: row.a === clickedRow['a'] ? !row['k'] : row['k']}));

        setRows(newRows);
    };

    return (
        <React.Fragment>
            <div style={{ position: "fixed", backgroundColor: "#142937" }}><Checkbox checked={hideAll} label="Hide All" onChange={checked => setHideAll(checked)} /></div>
            <table style={{ borderCollapse: "collapse" }}>
                <tbody>
                   <tr>
                        <TdHeader>Button</TdHeader>
                        <Td><Button hidden={hideAll} type="primary" tooltip="Hello there">Primary</Button></Td>
                        <Td><Button hidden={hideAll} type="primary" tooltip="Hello there" disabled>Primary disabled</Button></Td>
                        <Td><Button hidden={hideAll} type="primary" tooltip="Hello there" href="https://www.google.co.uk/">Primary link to google</Button></Td>
                        <Td><Button hidden={hideAll} type="secondary">Secondary</Button></Td>
                        <Td><Button hidden={hideAll} type="secondary">Secondary</Button></Td>
                        <Td><Button hidden={hideAll} type="primary">Custom size</Button></Td>
                        <Td><Button hidden={hideAll} type="primary" fullWidth>Full width</Button></Td>
                        <Td><Button hidden={hideAll} type="secondary" fullWidth>Secondary full width</Button></Td>
                        <Td><div style={{ width: '100px', height: '100px' }}><Button hidden={hideAll} type="primary" fullWidth fullHeight>Fill</Button></div></Td>
                    </tr>
                    <tr>
                        <TdHeader>Icon Button</TdHeader>
                        <Td>
                            <IconButton hidden={hideAll} type="primary"><DeleteIcon /></IconButton>
                            <IconButton hidden={hideAll} type="primary">{EDIT}</IconButton>
                            <IconButton hidden={hideAll} type="primary">{TICK}</IconButton>
                            <IconButton hidden={hideAll} type="primary">{DASH}</IconButton>
                            <IconButton hidden={hideAll} type="primary">{CROSS}</IconButton>
                            <IconButton hidden={hideAll} type="primary">{SEARCH}</IconButton>
                        </Td>
                        <Td>
                            <IconButton hidden={hideAll} type="primary" disabled><DeleteIcon /></IconButton>
                            <IconButton hidden={hideAll} type="primary" disabled>{EDIT}</IconButton>
                            <IconButton hidden={hideAll} type="primary" disabled>{TICK}</IconButton>
                            <IconButton hidden={hideAll} type="primary" disabled>{DASH}</IconButton>
                            <IconButton hidden={hideAll} type="primary" disabled>{CROSS}</IconButton>
                            <IconButton hidden={hideAll} type="primary" disabled>{SEARCH}</IconButton>
                        </Td>
                        <Td>
                            <IconButton hidden={hideAll} type="secondary"><DeleteIcon /></IconButton>
                            <IconButton hidden={hideAll} type="secondary">{EDIT}</IconButton>
                            <IconButton hidden={hideAll} type="secondary">{TICK}</IconButton>
                            <IconButton hidden={hideAll} type="secondary">{DASH}</IconButton>
                            <IconButton hidden={hideAll} type="secondary">{CROSS}</IconButton>
                            <IconButton hidden={hideAll} type="secondary">{SEARCH}</IconButton>
                        </Td>
                        <Td>
                            <IconButton hidden={hideAll} type="secondary" disabled><DeleteIcon /></IconButton>
                            <IconButton hidden={hideAll} type="secondary" disabled>{EDIT}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" disabled>{TICK}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" disabled>{DASH}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" disabled>{CROSS}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" disabled>{SEARCH}</IconButton>
                        </Td>
                        <Td>
                            <IconButton hidden={hideAll} type="primary" fullWidth><DeleteIcon /></IconButton>
                            <IconButton hidden={hideAll} type="primary" fullWidth>{EDIT}</IconButton>
                            <IconButton hidden={hideAll} type="primary" fullWidth>{TICK}</IconButton>
                            <IconButton hidden={hideAll} type="primary" fullWidth>{DASH}</IconButton>
                            <IconButton hidden={hideAll} type="primary" fullWidth>{CROSS}</IconButton>
                            <IconButton hidden={hideAll} type="primary" fullWidth>{SEARCH}</IconButton>
                        </Td>
                        <Td>
                            <IconButton hidden={hideAll} type="secondary" fullWidth><DeleteIcon /></IconButton>
                            <IconButton hidden={hideAll} type="secondary" fullWidth>{EDIT}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" fullWidth>{TICK}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" fullWidth>{DASH}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" fullWidth>{CROSS}</IconButton>
                            <IconButton hidden={hideAll} type="secondary" fullWidth>{SEARCH}</IconButton>
                        </Td>
                        <Td>
                            <div style={{ width: '100px', height: '100px' }}><IconButton hidden={hideAll} type="primary" fullWidth fullHeight><DeleteIcon /></IconButton></div>
                            <div style={{ width: '100px', height: '100px' }}><IconButton hidden={hideAll} type="primary" fullWidth fullHeight>{EDIT}</IconButton></div>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Tooltip</TdHeader>
                        <Td><Tooltip hidden={hideAll} label="This tooltip" preferredPlacement="right"><span>Just text</span></Tooltip></Td>
                    </tr>
                    <tr>
                        <TdHeader>Switch</TdHeader>
                        <Td><Switch hidden={hideAll} labelTrue="Enabled" labelFalse="Disabled" state={switchState} onChange={(state) => setSwitchState(state)} /></Td>
                        <Td><Switch hidden={hideAll} disabled labelTrue="Enabled" labelFalse="Disabled" state={switchState} onChange={(state) => setSwitchState(state)} /></Td>
                        <Td><Switch hidden={hideAll} fullWidth labelTrue="TRUE" labelFalse="FALSE" state={switchState} onChange={(state) => setSwitchState(state)} /></Td>
                        <Td><div style={{ height: '100px' }}><Switch hidden={hideAll} fullHeight labelTrue="Enabled" labelFalse="Disabled" state={switchState} onChange={(state) => setSwitchState(state)} /></div></Td>
                    </tr>
                    <tr>
                        <TdHeader>Tabs</TdHeader>
                        <Td>
                            <div style={{ height: '300px' }}>
                                <Tabs hidden={hideAll} selectedTabKey={selectedTabKey} onChange={t => setSelectedTabKey(t)}>
                                    <Tab tabKey="tab_1" label="Tab One">
                                        This is tab 1
                                    </Tab>
                                    <Tab tabKey="tab_2" label="Tab Two">
                                        <div style={{ backgroundColor: 'red' }}>
                                            This is tab 2
                                        </div>
                                    </Tab>
                                    <Tab tabKey="tab_3" label="Tab Three">
                                        {[...Array(100).keys()].map(i => <div key={i}>This is tab 3 = {i}</div>)}
                                    </Tab>
                                </Tabs>
                            </div>
                        </Td>
                        <Td>
                            <div style={{ height: '300px', width: '600px' }}>
                                <Tabs hidden={hideAll} selectedTabKey={selectedTabKey} onChange={t => setSelectedTabKey(t)}>
                                    <Tab tabKey="tab_1" label="Tab One">
                                        This is tab 1
                                    </Tab>
                                    <Tab tabKey="tab_2" label="Tab Two">
                                        <div style={{ backgroundColor: 'red' }}>
                                            This is tab 2
                                        </div>
                                    </Tab>
                                    <Tab tabKey="tab_3" label="Tab Three">
                                        {[...Array(100).keys()].map(i => <div key={i}>This is tab 3 = {i}</div>)}
                                    </Tab>
                                    <Tab tabKey="tab_4" label="Tab Four">
                                        {[...Array(100).keys()].map(i => <div key={i}>This is tab 4 = {i}</div>)}
                                    </Tab>
                                    <Tab tabKey="tab_5" label="Tab Five">
                                        {[...Array(100).keys()].map(i => <div key={i}>This is tab 5 = {i}</div>)}
                                    </Tab>
                                    <Tab tabKey="tab_6" label="Tab Six">
                                        {[...Array(100).keys()].map(i => <div key={i}>This is tab 6 = {i}</div>)}
                                    </Tab>
                                </Tabs>
                            </div>
                        </Td>
                        <Td>
                            <MBox display="flex" flexDirection="row" style={{ width: '600px', backgroundColor: CONTAINER }}>
                                <Tabs hidden={hideAll} selectedTabKey={selectedTabKey} onChange={t => setSelectedTabKey(t)}>
                                    <Tab tabKey="tab_1" label="Tab One" />
                                    <Tab tabKey="tab_2" label="Tab Two" />
                                </Tabs>
                                <MBox width="200px" alignItems="center" display="flex" marginRight="8px">
                                    <SearchField hidden={hideAll} value={searchfieldValue} onChange={v => setSearchfieldValue(v)} />
                                </MBox>
                            </MBox>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>TextField</TdHeader>
                        <Td><TextField hidden={hideAll} value={textfieldValue} placeholder="This placeholder" onChange={v => setTextfieldValue(v)} /></Td>
                        <Td><TextField hidden={hideAll} value={textfieldValue} placeholder="read only" readonly={true} onChange={v => setTextfieldValue(v)} /></Td>
                        <Td><TextField hidden={hideAll} disabled value={textfieldValue} placeholder="This placeholder" onChange={v => setTextfieldValue(v)} /></Td>
                        <Td><TextField hidden={hideAll} error value={textfieldValue} placeholder="This placeholder" onChange={v => setTextfieldValue(v)} /></Td>
                        <Td><TextField hidden={hideAll} error="This error" value={textfieldValue} placeholder="This placeholder" onChange={v => setTextfieldValue(v)} /></Td>
                        
                    </tr>
                    <tr>
                        <TdHeader>SearchField</TdHeader>
                        <Td><SearchField hidden={hideAll} value={searchfieldValue} onChange={v => setSearchfieldValue(v)} /></Td>
                        <Td><SearchField hidden={hideAll} value={searchfieldValue} placeholder="Search this example" onChange={v => setSearchfieldValue(v)} /></Td>
                        <Td><SearchField hidden={hideAll} contained value={searchfieldValue} placeholder="Search this window" onChange={v => setSearchfieldValue(v)} /></Td>
                    </tr>
                    <tr>
                        <TdHeader>Loading</TdHeader>
                        <Td>
                            <div style={{ height: '400px', width: '400px' }}>
                                <Loading hidden={hideAll} />
                            </div>
                        </Td>
                        <Td>
                            <div style={{ height: '300px', width: '200px' }}>
                                <Container fullHeight fullWidth>
                                    <Loading hidden={hideAll} />
                                </Container>
                            </div>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Calendar</TdHeader>
                        <Td>
                            <div style={{ height: '550px', width: '900px' }}>
                                <Schedule
                                    eventsOnCalendar={[
                                        { startDate: new Date(2021, 9, 3), endDate: new Date(2021, 9, 13), eventID: 'KKS22300002012' },
                                        { startDate: new Date(2021, 9, 12), endDate: new Date(2021, 9, 15), eventID: 'RS22300002012' },
                                        { startDate: new Date(2021, 9, 13), endDate: new Date(2021, 9, 13), eventID: '000000122212101' },
                                        { startDate: new Date(2021, 8, 15), endDate: new Date(2021, 8, 16), eventID: 'O20002102312783' }
                                    ]}
                                    onShowDetails={(e) => console.log(e)}
                                />
                            </div>
                        </Td>
                        <Td>
                            <Container>
                                <Schedule
                                    eventsOnCalendar={[
                                        { startDate: new Date(2021, 9, 3), endDate: new Date(2021, 9, 13), eventID: 'KKS22300002012' },
                                        { startDate: new Date(2021, 9, 12), endDate: new Date(2021, 9, 15), eventID: 'RS22300002012' },
                                        { startDate: new Date(2021, 9, 13), endDate: new Date(2021, 9, 13), eventID: '000000122212101' },
                                        { startDate: new Date(2021, 8, 15), endDate: new Date(2021, 8, 16), eventID: 'O20002102312783' }
                                    ]}
                                    onShowDetails={(e) => console.log(e)}
                                />
                            </Container>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Dropdown</TdHeader>
                        <Td><Dropdown hidden={hideAll} label="This label" selectedId={drowndownSelection} idProperty="mykey" valueProperty="value" items={dropdownItems} onChange={i => setDrowndownSelection(i.mykey)} /></Td>
                        <Td><Dropdown hidden={hideAll} disabled label="This label" selectedId={drowndownSelection} idProperty="mykey" valueProperty="value" items={dropdownItems} onChange={i => setDrowndownSelection(i.mykey)} /></Td>
                        <Td><Dropdown hidden={hideAll} error label="This label" selectedId={drowndownSelection} idProperty="mykey" valueProperty="value" items={dropdownItems} onChange={i => setDrowndownSelection(i.mykey)} /></Td>
                        <Td><Dropdown hidden={hideAll} error="This error" label="This label" selectedId={drowndownSelection} idProperty="mykey" valueProperty="value" items={dropdownItems} onChange={i => setDrowndownSelection(i.mykey)} /></Td>
                    </tr>
                    <tr>
                        <TdHeader>EditableLabel</TdHeader>
                        <Td><EditableLabel hidden={hideAll} value={editableLabelValue} typography="body" onChange={value => setEditableLabelValue(value)} /></Td>
                        <Td><EditableLabel hidden={hideAll} value={editableLabelValue} typography="mini_header" onChange={value => setEditableLabelValue(value)} /></Td>
                        <Td><EditableLabel hidden={hideAll} value={editableLabelValue} typography="subtitle" onChange={value => setEditableLabelValue(value)} /></Td>
                        <Td><EditableLabel hidden={hideAll} value={editableLabelValue} typography="heading_01" onChange={value => setEditableLabelValue(value)} /></Td>
                        <Td><EditableLabel hidden={hideAll} value={editableLabelValue} typography="heading_02" onChange={value => setEditableLabelValue(value)} /></Td>
                        <Td><EditableLabel hidden={hideAll} value={editableLabelValue} typography="heading_03" onChange={value => setEditableLabelValue(value)} /></Td>
                    </tr>
                    <tr>
                        <TdHeader>Label</TdHeader>
                        <Td><Label hidden={hideAll} typography="body">{editableLabelValue}</Label></Td>
                        <Td><Label hidden={hideAll} typography="mini_header">{editableLabelValue}</Label></Td>
                        <Td><Label hidden={hideAll} typography="subtitle">{editableLabelValue}</Label></Td>
                        <Td><Label hidden={hideAll} typography="heading_01">{editableLabelValue}</Label></Td>
                        <Td><Label hidden={hideAll} typography="heading_02">{editableLabelValue}</Label></Td>
                        <Td><Label hidden={hideAll} typography="heading_03">{editableLabelValue}</Label></Td>
                    </tr >
                    <tr>
                        <TdHeader>Checkbox</TdHeader>
                        <Td><Checkbox hidden={hideAll} checked={checkboxAChecked} onChange={checked => setCheckboxAChecked(checked)} /></Td>
                        <Td><Checkbox hidden={hideAll} checked={checkboxBChecked} label="This label" onChange={checked => setCheckboxBChecked(checked)} /></Td>
                        <Td><Checkbox hidden={hideAll} checked={[checkboxAChecked, checkboxBChecked]} onChange={checked => { setCheckboxAChecked(checked); setCheckboxBChecked(checked) }} /></Td>
                        <Td>
                            <ExpansionPanel style={{ backgroundColor: CONTAINER }}>
                                <ExpansionPanelSummary>
                                    <Checkbox hidden={hideAll} checked={checkboxBChecked} stopPropagation label="Stop propagation test" onChange={checked => setCheckboxBChecked(checked)} />
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    Stop propagation not working?
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>RadioButton</TdHeader>
                        <Td><RadioButton hidden={hideAll} checked={radioButtonChoice === 'a'} onSelected={() => setRadioButtonChoice('a')} /></Td>
                        <Td><RadioButton hidden={hideAll} checked={radioButtonChoice === 'b'} label="This label" onSelected={() => setRadioButtonChoice('b')} /></Td>
                        <Td>
                            <ExpansionPanel style={{ backgroundColor: CONTAINER }}>
                                <ExpansionPanelSummary>
                                    <RadioButton hidden={hideAll} checked={radioButtonChoice === 'c'} stopPropagation label="Stop propagation test" onSelected={() => setRadioButtonChoice('c')} />
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    Stop propagation not working?
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Css Scroll</TdHeader>
                        <Td>
                            <div style={{width: '550px', height: '250px' }}>
                                <div className={'scroll'}>
                                    <p>
                                        Scrollable text remains in bounds:
                                    </p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                        Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                        Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                        Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                        Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                        Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                        Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                                    </p>  
                                </div>
                            </div>
                        </Td>
                        <Td>
                            <div style={{width: '400px', height: '250px' }}>
                                <div className={'scroll'}>
                                    <p>
                                        Scrollable verticle:
                                    </p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                        Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                        Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                        Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                        Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                        Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                        Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                        Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                        Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                        Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                        Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                        Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                        Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                                    </p>
                                </div>
                            </div>
                        </Td>
                        <Td>
                            <div style={{width: '400px', height: '250px' }}>
                                <div className={'scroll'}>
                                    <p>
                                        Scrollable horizontal:
                                    </p>
                                    <p style={{width: '800px'}}>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                        Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                        Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                        Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                        Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                        Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                        Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                                    </p>
                                </div>
                            </div>
                        </Td>
                        <Td>
                            <div style={{width: '400px', height: '250px' }}>
                                <div className={'scroll'}>
                                    <p>
                                        Scrollable both:
                                    </p>
                                    <p style={{width: '600px'}}>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                        Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                        Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                        Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                        Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                        Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                        Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                        Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                        Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                        Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                        Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                        Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                        Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                                    </p>
                                </div>
                            </div>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Container</TdHeader>
                        <Td><Container hidden={hideAll}>Container content goes here.</Container></Td>
                        <Td>
                            <div style={{ margin: 8 }}><Container hidden={hideAll}>Container content goes here.</Container></div>
                            <div style={{ margin: 8, height: '100px', width: '100px' }}><Container hidden={hideAll} fullHeight fullWidth>Container</Container></div>
                            <div style={{ margin: 8 }}><Container hidden={hideAll}>Container content goes here.</Container></div>
                        </Td>
                        <Td><Container hidden={hideAll} headerTitle="This header">Container content goes here</Container></Td>
                        <Td>
                            <Container hidden={hideAll} headerTitle="This header" headerActions={<React.Fragment>
                                <IconButton type="secondary"><MFileCopyIcon fontSize="small" /></IconButton>
                                <IconButton type="secondary"><MFInfoIcon fontSize="small" /></IconButton>
                            </React.Fragment>}>
                                Container content goes here
                            </Container>
                        </Td>
                        <Td>
                            <Container hidden={hideAll} fullWidth headerTitle="This header" headerActions={[
                                <IconButton key="1" type="secondary"><MFileCopyIcon fontSize="small" /></IconButton>,
                                <IconButton key="2" type="secondary"><MFInfoIcon fontSize="small" /></IconButton>
                            ]}>
                                Container with full width
                            </Container>
                        </Td>
                        <Td><div style={{ height: '200px', }}><Container hidden={hideAll} fullHeight headerTitle="This header" headerActions={[
                            <IconButton key="1" type="secondary"><MFileCopyIcon fontSize="small" /></IconButton>,
                            <IconButton key="2" type="secondary"><MFInfoIcon fontSize="small" /></IconButton>]
                        }>Container with full height</Container></div></Td>
                        <Td>
                            <div style={{ height: '200px', }}>
                                <Container hidden={hideAll} fullHeight headerTitle="This header" headerActions={<React.Fragment>
                                    <IconButton type="secondary"><MFileCopyIcon fontSize="small" /></IconButton>
                                    <IconButton type="secondary"><MFInfoIcon fontSize="small" /></IconButton>
                                </React.Fragment>}>
                                    Container with full height
                                </Container>
                            </div>
                        </Td>
                        <Td>
                            <Container hidden={hideAll} headerTitle="This header">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                            </Container>
                        </Td>
                        <Td>
                            <div style={{ height: '200px', }}>
                                <Container hidden={hideAll} fullHeight headerTitle="This header">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi tincidunt fringilla quam, non blandit turpis tincidunt at.
                                    Cras dignissim leo eget nunc bibendum iaculis. Phasellus vulputate dolor non ultrices facilisis.
                                    Nullam imperdiet felis magna. Quisque consequat nec nunc id fringilla. Ut sit amet elit eget nunc efficitur fermentum.
                                    Integer fermentum tincidunt ornare. Fusce eget leo massa. Suspendisse feugiat sagittis ultrices.
                                    Nam semper nisl leo, vehicula porta est tempor vitae. Donec mi libero, varius id arcu at, porttitor posuere sem.
                                    Nunc vulputate tristique sapien non dapibus. Integer vitae arcu imperdiet, sagittis ex a, varius dolor.
                                    Nullam erat enim, ornare vel nibh quis, ultricies gravida enim. Nulla facilisi.
                                </Container>
                            </div>
                        </Td>
                        <Td>
                            <div style={{ height: '200px', }}>
                                <Container hidden={hideAll} fullHeight headerTitle="This header">
                                    <div style={{ width: '180px', height: '100%', backgroundColor: 'red' }}></div>
                                </Container>
                            </div>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Dialog</TdHeader>
                        <Td>
                            <Button type="primary" onClick={() => setDialog1Open(true)}>Open dialog</Button>
                            <div>
                                <Label typography="body">{dialogSelection}</Label>
                            </div>
                            {dialog1Open && <PreviewDialog
                                currentSelection={dialogSelection}
                                onClose={() => setDialog1Open(false)}
                                onApply={(selection) => {
                                    setDialog1Open(false);
                                    setDialogSelection(selection);
                                }} />}
                        </Td>
                        <Td>
                            <Button type="primary" onClick={() => setDialog2Open(true)}>Open dialog</Button>
                            <div>
                                <Label typography="body">{dialogSelection}</Label>
                            </div>
                            {dialog2Open && <PreviewDialog2
                                title="This header"
                                currentSelection={dialogSelection}
                                onClose={() => setDialog2Open(false)}
                                onApply={(selection) => {
                                    setDialog2Open(false);
                                    setDialogSelection(selection);
                                }} />}
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Stepper</TdHeader>
                        <Td>
                            <Stepper hidden={hideAll} selectedStep={selectedStep} steps={["Step 1", "Step 2", "This is Step 3", "Step 4"]} />
                            <Button type="primary" onClick={() => setSelectedStep((selectedStep - 1) % 4)} disabled={selectedStep === 0}>Prev</Button>
                            <Button type="primary" onClick={() => setSelectedStep((selectedStep + 1) % 4)}>Next</Button>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Table</TdHeader>
                        <Td>
                            <div style={{ height: '300px', width: '400px' }}>
                                <Table hidden={hideAll}
                                    columns={[
                                        {
                                            type: "menu" as const, columnKey: 1, displayName: '', width: 32, menuItems: [
                                                { label: "item 1", onClick: row => alert(`item 1: ${row.c}`) },
                                                { label: "item 2", onClick: row => alert(`item 2: ${row.c}`) },
                                                { label: "item 3", onClick: row => alert(`item 3: ${row.c}`) }
                                            ]
                                        },
                                        { type: "button" as const, columnKey: 2, displayName: '', width: 64, label: "Button", onClick: row => alert(row.c) },
                                        { type: "value" as const, columnKey: 3, selector: 'c', displayName: 'display C', width: 60 },
                                        { type: "value" as const, columnKey: 4, selector: 'd', displayName: 'display D', width: 100 },
                                        { type: "value" as const, columnKey: 5, selector: 'e', displayName: 'display E', width: 100 },
                                        { type: "value" as const, columnKey: 6, selector: r => r.f, displayName: 'display F', width: 100 }
                                    ]}
                                    rows={Array.from(Array(10000).keys()).map(i => ({ a: i, b: i * 10, c: i * 100, d: i * 1000, e: i * 10000, f: i * 100000 }))} />
                            </div>
                        </Td>
                        <Td>
                            <div style={{ height: '300px', width: '400px' }}>
                                <Table hidden={hideAll}
                                    columns={[
                                        {
                                            type: "menu" as const, columnKey: 1, displayName: '', width: 32, menuItems: [
                                                { label: "item 1", onClick: row => alert(`item 1: ${row.c}`) },
                                                { label: "item 2", onClick: row => alert(`item 2: ${row.c}`) },
                                                { label: "item 3", onClick: row => alert(`item 3: ${row.c}`) }
                                            ]
                                        },
                                        { type: "button" as const, columnKey: 2, displayName: '', width: 64, label: "Button", onClick: row => alert(row.c) },
                                        { type: "value" as const, columnKey: 3, selector: 'c', displayName: 'display C', width: 60 },
                                        { type: "value" as const, columnKey: 4, selector: 'd', displayName: 'display D', width: 100 },
                                        { type: "value" as const, columnKey: 5, selector: 'e', displayName: 'display E', width: 100 },
                                        { type: "value" as const, columnKey: 6, selector: r => r.f, displayName: 'display F', width: 100 }
                                    ]}
                                    rows={Array.from(Array(10000).keys()).map(i => ({
                                        c: i * 10,
                                        d: i * 100,
                                        e: i * 1000,
                                        f: i * 10000,
                                    }))}
                                    selectedRow={selectedTableRowIndex}
                                    onRowClick={(row, rowIndex) => setSelectedTableRowIndex(rowIndex)} />
                            </div>
                        </Td>
                        <Td>
                            <div style={{ height: '300px', width: '400px' }}>
                                <Table hidden={hideAll} disableResizeColumns={true}
                                    columns={[
                                        {
                                            type: "menu" as const, columnKey: 1, displayName: '', width: 32, menuItems: [
                                                { label: "item 1", onClick: row => alert(`item 1: ${row.c}`) },
                                                { label: "item 2", onClick: row => alert(`item 2: ${row.c}`) },
                                                { label: "item 3", onClick: row => alert(`item 3: ${row.c}`) }
                                            ]
                                        },
                                        { type: "button" as const, columnKey: 3, displayName: '', width: 64, label: "Button", onClick: row => alert(row.c) },
                                        { type: "value" as const, columnKey: 4, selector: 'c', displayName: 'display C', width: 60 },
                                        { type: "value" as const, columnKey: 5, selector: 'd', displayName: 'display D', width: 100 },
                                        { type: "value" as const, columnKey: 6, selector: 'e', displayName: 'display E', width: 100 },
                                        { type: "value" as const, columnKey: 6, selector: r => r.f, displayName: 'display F', width: 100 }
                                    ]}
                                    rows={Array.from(Array(10000).keys()).map(i => ({
                                        c: i * 10,
                                        d: i * 100,
                                        e: i * 1000,
                                        f: i * 10000,
                                    }))}
                                    selectedRow={selectedTableRowIndex}
                                    onRowClick={(row, rowIndex) => setSelectedTableRowIndex(rowIndex)} />
                            </div>
                        </Td>
                    </tr>
                    <tr>
                        <TdHeader>Table Reordering</TdHeader>
                            <Td>
                            <div style={{ height: "300px", width: "100%" }}>
                                <Table
                                    canReOrder={true}
                                    hidden={hideAll}
                                    selectedRow={selectedRow}
                                    onRowClick={(row, rowIndex): void =>
                                        onrowclick(row, rowIndex)
                                    }
                                    columns={[
                                        {
                                            type: "value" as const,
                                            columnKey: 1,
                                            selector: "a",
                                            displayName: "display A",
                                            width: 60,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 2,
                                            selector: "b",
                                            displayName: "display B",
                                            width: 60,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 4,
                                            selector: "c",
                                            displayName: "display C",
                                            width: 60,
                                            disableReOrder: true,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 5,
                                            selector: "d",
                                            displayName: "display D",
                                            width: 100,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 6,
                                            selector: "e",
                                            displayName: "display E",
                                            width: 100,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 7,
                                            selector: (r) => r.f,
                                            displayName: "display F",
                                            width: 100,
                                            customReOrder: customReorderOne,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 8,
                                            selector: "g",
                                            displayName: "display G",
                                            width: 100,
                                            customReOrder: customReorderTwo,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 9,
                                            selector: "UserRole",
                                            displayName: "display H",
                                            width: 100,
                                            customReOrder: customReorderThree,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 11,
                                            selector: "i",
                                            displayName: "display I",
                                            width: 100,
                                        },
                                        {
                                            type: "value" as const,
                                            columnKey: 12,
                                            selector: "j",
                                            displayName: "display J",
                                            width: 100,
                                            customReOrder: customReorderFour,
                                        },
                                        {
                                            type: "check" as const,
                                            columnKey: 13,
                                            selector: "k",
                                            displayName: "display K",
                                            width: 100,
                                            disableReOrder: true,
                                            onClick: onCheckClick
                                        },
                                    ]}
                                    rows={rows}
                                />
                            </div>
                            </Td>
                    </tr>
                </tbody>
            </table>
        </React.Fragment>);
}
